# Action types
export CLEAR_TABLE_DATA = 'CLEAR_TABLE_DATA'
export INIT_TABLE_DATA   = 'INIT_TABLE_DATA'
export SET_TABLE_DATA   = 'SET_TABLE_DATA'
